<template>

    <main-layout class="list-bouteilles">

        <app-header icon="bottle">
            Bouteilles
        </app-header>

        <action-bar :back="{ name: 'home' }">
            <a class="btn add btn-full" id="main-action" href="javascript: void 0" @click.prevent="addBouteille">
                <strong>Ajouter / Scanner</strong>une bouteille
                <i class="icon-otag"></i>
            </a>
        </action-bar>

        <filter-bar @searchBarChanged="updateSearch" @filterValChanged="changeList" @toggleMine="changeShowMine"
            :isBouteille="true" :gotFilter="true" filterText="Bouteilles actives"
            placeholderFilter="Recherche par code, fluide, otag" type-history="bouteille">
        </filter-bar>

        <div class="filtre-type-fluide wrap">
            <div class="checkbox ff">
                <input type="checkbox" id="filtertype-ff" name="filtertype-ff" v-model="ff"
                    @change="updateTypeBouteille">
                <label for="filtertype-ff"><i class="icon-valid"></i> Fluide frigo</label>
            </div>
            <div class="checkbox rec">
                <input type="checkbox" id="filtertype-rec" name="filtertype-rec" v-model="rec"
                    @change="updateTypeBouteille">
                <label for="filtertype-rec"><i class="icon-valid"></i> Récup</label>
            </div>
            <div class="checkbox tf">
                <input type="checkbox" id="filtertype-tf" name="filtertype-tf" v-model="tf"
                    @change="updateTypeBouteille">
                <label for="filtertype-tf"><i class="icon-valid"></i> Transfert</label>
            </div>
        </div>

        <div id="bouteilles-item" class="list list-bout" v-show="listVisible === 'active'">
            <bouteille-item v-for="bouteille in filteredList" v-bind:key="bouteille.id"
                :bouteille="bouteille" :info="bouteilleInfoMap[bouteille.id] || null"></bouteille-item>
        </div>

        <div id="bouteilles-item-inact" class="list list-bout" v-show="listVisible === 'inactive'">
            <bouteille-item v-for="bouteille in filteredListInact" v-bind:key="bouteille.id"
                :bouteille="bouteille" :info="bouteilleInfoMap[bouteille.id] || null"></bouteille-item>
        </div>


        <div class="pagination-buttons" style="text-align: center">
            <button @click="previousPage"
                v-show="paginator[this.type]['showPreviousButton'] === true && this.strSearch === ''"
                style="max-width: 150px; font-size: 10px; text-transform: capitalize; margin-right: 10px">
                &lt;&lt; précédent</button>
                    <button @click="nextPage"
                        v-show="paginator[this.type]['showLastButton'] === true && this.strSearch === ''"
                        style="max-width: 150px; font-size: 10px; text-transform: capitalize">suivant >></button>
        </div>


    </main-layout>

</template>

<script>

import BouteilleItem from './BouteilleItem.vue'
import Bouteille from '../../js/models/Bouteille'
import History from "../../js/core/History";

export default {

    data() {
        return {
            paginator: [
                {
                    lastPage: 1000,
                    currentPage: 1,
                    showPreviousButton: false,
                    showLastButton: true,
                    pageSize: 15
                },
                {
                    lastPage: 1000,
                    currentPage: 1,
                    showPreviousButton: false,
                    showLastButton: true,
                    pageSize: 15
                },
            ],
            bottlesActive: [],
            bottlesInactive: [],
            allBouteillesActives: [],
            allBouteillesInactives: [],
            bouteilleInfoMap: {},
            strSearch: '',
            listVisible: 'active',
            ff: true,
            rec: true,
            tf: true,
            type: 1
        }
    },

    methods: {

        changeShowMine(val) {
            this.showOnlyMine = val;
            this.filterBouteilles();
        },
        filterBouteilles() {
            if (this.listVisible === "active") {
                if (this.showOnlyMine) {
                    this.bottlesActive = _.filter(this.allBouteillesActives, function (bouteille) {
                        return bouteille.favori !== null && bouteille.favori != undefined && bouteille.favori.id === this.$user.id;
                    }.bind(this));
                } else {
                    this.bottlesActive = this.allBouteillesActives;
                }
            } else {
                if (this.showOnlyMine) {
                    this.bottlesInactive = _.filter(this.allBouteillesInactives, function (bouteille) {
                        return bouteille.favori !== null && bouteille.favori != undefined && bouteille.favori.id === this.$user.id;
                    }.bind(this));
                } else {
                    this.bottlesInactive = this.allBouteillesInactives;
                }
            }
        },

        async fetchBottles() {
            try {
                const data = await Bouteille.getList();

                let bottlesActives = _.filter(data, b => b.actif === true);
                this.bottlesActive = _.sortBy(bottlesActives, ['created_at']).reverse();
                this.allBouteillesActives = this.bottlesActive;

                let bottlesInactives = _.filter(data, b => b.actif === false);
                this.bottlesInactive = _.sortBy(bottlesInactives, ['created_at']).reverse();
                this.allBouteillesInactives = this.bottlesInactive;

                // La qualification du contenu (Utilisée / Recyclé / Déchets) est calculée par
                // l'API et transmise dans etat_contenu : la reconstituer ici imposait de
                // relire toutes les opérations de toutes les bouteilles, et la règle aurait
                // fini par diverger de celle du back-office (MD-256).
                const infoMap = {};

                for (const bouteille of data) {
                    if (bouteille.etat_contenu) {
                        infoMap[bouteille.id] = bouteille.etat_contenu;
                    }
                }

                this.bouteilleInfoMap = infoMap;
            } catch (e) {
                // silent
            }
        },

        addBouteille() {
            Bouteille.askAddBouteille()
        },

        updateSearch(str) {
            this.strSearch = String(str[0]).toLowerCase()
        },

        changeList(filter) {
            if (filter === false) {
                this.listVisible = 'inactive'
                this.type = 0;
            } else {
                this.listVisible = 'active'
                this.type = 1;
            }
            this.filterBouteilles();
        },

        nextPage() {

            if (this.paginator[this.type]['currentPage'] < this.paginator[this.type]['lastPage']) {
                this.paginator[this.type]['currentPage']++;
            }

            this.updateButton();
        },

        previousPage() {
            if (this.paginator[this.type]['currentPage'] > 1) {
                this.paginator[this.type]['currentPage']--;
            }
            this.updateButton();
        },


        updateButton() {

            this.paginator[this.type]['showPreviousButton'] = this.paginator[this.type]['currentPage'] !== 1;
            this.paginator[this.type]['showLastButton'] = this.paginator[this.type]['currentPage'] !== this.paginator[this.type]['lastPage'];
            if (this.paginator[this.type]['lastPage'] === 0) {
                this.paginator[this.type]['showLastButton'] = false;
            }

            window.scrollTo(0, 0);
        },

        slicedItems(bottles) {
            if (this.strSearch !== '') {
                return bottles;
            } else {
                return bottles.slice(
                    (this.paginator[this.type]['currentPage'] - 1) * this.paginator[this.type]['pageSize'],
                    this.paginator[this.type]['currentPage'] * this.paginator[this.type]['pageSize'])
            }
        },

        async updateTypeBouteille() {
            await History.setHistory('bouteille', {
                'text': this.strSearch,
                'options': {
                    'ff': this.ff,
                    'rec': this.rec,
                    'tf': this.tf
                }
            })
        }

    },

    mounted: async function () {

        let history = await History.getHistory('bouteille');

        if (typeof history !== "undefined") {
            if (typeof history.text !== "undefined") {
                this.searchingBar = history.text;
                this.$emit('searchBarChanged', [this.searchingBar]);
            }

            if (history.options && typeof history.options.active !== "undefined") {
                this.filterActive = history.options.active;
                this.$emit('filterValChanged', this.filterActive);
            }

            if (history.options && typeof history.options.showMine !== "undefined") {
                this.showMine = history.options.showMine;
                this.$emit('toggleMine', this.showMine);
            }
        }
        this.fetchBottles()
    },

    computed: {

        filteredList() {
            let search = this.strSearch;
            let types = [];
            this.updateButton()

            if (this.ff) {
                types.push('Fluide frigorigène')
            }
            if (this.rec) {
                types.push('Récupération')
            }
            if (this.tf) {
                types.push('Transfert')
            }

            let listBottles = this.bottlesActive.filter(bouteille => {

                let check = false;
                if (bouteille.nom && bouteille.nom.nom.toLowerCase().includes(search)) {
                    check = true
                }

                if (bouteille.otag && bouteille.otag.includes(search)) {
                    check = true
                }

                if (bouteille.fournisseur && bouteille.fournisseur.nom.toLowerCase().includes(search)) {
                    check = true
                }

                if (_.has(bouteille, 'fluide') && bouteille.fluide !== null && bouteille.fluide.nom.toLowerCase().includes(search)) {
                    check = true
                }

                if (bouteille.code.toLowerCase().includes(search)) {
                    check = true
                }

                if (_.has(bouteille, 'type') && types.indexOf(bouteille.type) === -1) {
                    check = false
                }

                if (bouteille.restitution === true) {
                    check = false
                }

                if (bouteille.actif === false) {
                    check = false;
                }

                if (check) {
                    return bouteille
                }
            })

            this.paginator[1]['lastPage'] = Math.ceil(listBottles.length / this.paginator[1]['pageSize']);
            if (this.paginator[1]['lastPage'] < this.paginator[1]['currentPage']) {
                this.paginator[1]['currentPage'] = 1;
            }
            this.updateButton();
            return this.slicedItems(listBottles);

        },

        filteredListInact() {

            let search = this.strSearch;
            let types = [];
            this.updateButton()


            if (this.ff) {
                types.push('Fluide frigorigène')
            }
            if (this.rec) {
                types.push('Récupération')
            }
            if (this.tf) {
                types.push('Transfert')
            }

            let listBottles = this.bottlesInactive.filter(bouteille => {
                    let check = false;
                    if (bouteille.nom && bouteille.nom.nom.toLowerCase().includes(search)) {
                        check = true
                    }

                    if (bouteille.otag && bouteille.otag.includes(search)) {
                        check = true
                    }

                    if (bouteille.fournisseur && bouteille.fournisseur.nom.toLowerCase().includes(search)) {
                        check = true
                    }

                    if (_.has(bouteille, 'fluide') && bouteille.fluide !== null && bouteille.fluide.nom.toLowerCase().includes(search)) {
                        check = true
                    }

                    if (bouteille.code.toLowerCase().includes(search)) {
                        check = true
                    }

                    if (_.has(bouteille, 'type') && types.indexOf(bouteille.type) === -1) {
                        check = false
                    }

                    if (bouteille.restitution === true) {
                        check = false
                    }

                    if (bouteille.actif === true) {
                        check = false;
                    }

                    if (check) {
                        return bouteille
                    }
                })



            this.paginator[0]['lastPage'] = Math.ceil(listBottles.length / this.paginator[0]['pageSize']);
            if (this.paginator[0]['lastPage'] < this.paginator[0]['currentPage']) {
                this.paginator[0]['currentPage'] = 1;
            }
            return this.slicedItems(listBottles);


        }

    },

    components: {
        BouteilleItem
    }

}

</script>
<style>
#main-action .icon-otag {
    right: 5px;
    top: 50%;
    margin-top: -17px;
    font-size: 3rem;
}
</style>



// WEBPACK FOOTER //
// ListeBouteilles.vue?529cb754